import { getDisplayValue } from "../../formatting/string-manipulation";
import type { Field } from "../tabs/types";

export function buildLocationPinMapField(
  locationPinMapLink: string | undefined,
  index: number,
): Field {
  return {
    name: "Location Pin Map Link",
    type: "text",
    index,
    fullLine: true,
    value: getDisplayValue(locationPinMapLink),
  };
}
